import React, { useEffect, useState } from "react";
// import { BsXCircle } from "react-icons/bs";
import { useParams } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { PollApiCalls } from "../../apis/PollApiCalls";
import { UserApiCalls } from "../../apis/UserApiCalls";
import { useSession } from "../../hooks/useSession";
import { ReactComponent as YuJaLogo } from "../../images/yujalogo.svg";
import { ReactComponent as UnsupportedIcon } from "../../images/Unsupported.svg";
import {
    POLL_TYPE,
} from "../../utils/constants";
import {getDefaultUserSettings, transferUserSettings} from "../../utils/helpers";
import useQuery from "../../utils/queryparam";
import styles from "./Presentation.module.css";
import Skeleton from "react-loading-skeleton";
import ViewPresent from "./ViewPresent";
import {usePPTWebView} from "../../hooks/usePPTWebView";
import {applyLanguage} from "../../i18n";
import useWindowDimensions from "../../hooks/useWindowDimensions";


export default function PresentationPage() {
    const { t } = useTranslation();
    const window = useWindowDimensions();
    const { getPollRecordFromUniqueCode } = PollApiCalls();
    const { loadUser } = UserApiCalls();
    const { checkExpired } = useSession();
    const { pollCode, serialNo } = useParams();
    let query = useQuery();
    const {getToken, parseToken} = usePPTWebView();

    const [isLoading, setIsLoading] = useState(true);
    const [pollAvailable, setPollAvailable] = useState(true);
    const [isValidPollType, setIsValidPollType] = useState(true);
    const [internalError, setInternalError] = useState(false);

    const [pollData, setPollData] = useState({});
    const [poll, setPoll] = useState({});
    const [userSettings, setUserSettings] = useState(getDefaultUserSettings());
    const [resetCount, setResetCount] = useState(0);


    const loadPublishedData = () => {
        setResetCount(resetCount + 1);
        const { userId } = parseToken();
        return getPollRecordFromUniqueCode(pollCode).then((pollDetail) => {
            if (!pollDetail || !pollDetail.poll) {
                setInternalError(true);
                return;
            }
            const { poll, questions } = pollDetail;
            const { index1Pk } = poll;
            const ownerId = index1Pk.substring("U#".length);

            if (ownerId !== userId) {
                setPollAvailable(false);
                return;
            }

            if (poll?.pollType !== POLL_TYPE.MERGED_POLL && poll?.pollType !== POLL_TYPE.ATTENDANCE) {
                setIsValidPollType(false);
                return;
            }

            pollDetail.questions = questions.sort((a, b) => a.serialNo - b.serialNo);
            setPoll(poll);
            setPollData(pollDetail);
        });
    }

    useEffect(() => {
        let token = getToken();

        if (!token || checkExpired(token)) {
            setPollAvailable(false);
            return;
        }

        const { institutionId, userId, language } = parseToken();
        applyLanguage(language);

        let promise1 = loadUser(institutionId, userId).then(res => {
            let { settings = {} } = res;
            settings = transferUserSettings(settings);
            setUserSettings(settings);
        });

        let promise2 = loadPublishedData();


        Promise.all([promise1, promise2]).catch((error) => {
            console.log(error);
            setInternalError(true);
        }).finally(() => {
            setIsLoading(false);
        });
    }, []);


    if (isLoading) {
        return (
            <div className={styles.row} style={{width: "100%", height: "100%", }}>
                <div className={`${styles.leftPart} ${styles.column}`} style={{alignItems: "center", gap: 15}}>
                    <div style={{flex: 1}}/>
                    <Skeleton borderRadius={3} height={23} inline={true} width={170} />
                    <Skeleton borderRadius={3} height={45} inline={true} width={250} />
                    <Skeleton borderRadius={"50%"} height={240} inline={true} width={240} style={{marginTop: 25}}/>
                    <div style={{flex: 2}}/>
                </div>

                <div className={`${styles.rightPart} ${styles.column}`} style={{gap: 15}}>
                    {!!serialNo &&
                        <>
                            <Skeleton borderRadius={3} height={35} inline={true} width={210} />
                            <Skeleton borderRadius={3} height={18} inline={true} width={100} />
                            <Skeleton borderRadius={3} height={90} inline={true} width={"100%"} />
                            <Skeleton borderRadius={3} height={23} inline={true} width={120} />

                            <div className={styles.column} style={{gap: 12}}>
                                <Skeleton borderRadius={4} height={74} inline={true} width={"100%"} />
                                <Skeleton borderRadius={4} height={74} inline={true} width={"100%"} />
                                <Skeleton borderRadius={4} height={74} inline={true} width={"100%"} />
                                <Skeleton borderRadius={4} height={74} inline={true} width={"100%"} />
                            </div>
                            <div className={styles.row} style={{flex: 1, alignItems: "end", justifyContent: "end", gap: 15}}>
                                <Skeleton borderRadius={4} height={40} inline={true} width={120} />
                                <Skeleton borderRadius={4} height={40} inline={true} width={120} />
                            </div>
                        </>
                    }


                    {!serialNo &&
                        <>
                            <div className={styles.row} style={{width: "100%"}}>
                                <Skeleton borderRadius={4} height={32} inline={true} width={200}/>
                                <div style={{flex: 1, minWidth: 15}}/>
                                <Skeleton borderRadius={4} height={40} inline={true} width={131}/>
                            </div>


                            <div className={styles.column} style={{gap: 12, width: "100%"}}>
                                <Skeleton borderRadius={4} height={70} inline={true} width={"100%"}/>
                                <Skeleton borderRadius={4} height={70} inline={true} width={"100%"}/>
                                <Skeleton borderRadius={4} height={70} inline={true} width={"100%"}/>
                                <Skeleton borderRadius={4} height={70} inline={true} width={"100%"}/>
                                <Skeleton borderRadius={4} height={70} inline={true} width={"100%"}/>
                                <Skeleton borderRadius={4} height={70} inline={true} width={"100%"}/>
                            </div>

                        </>
                    }
                </div>
            </div>
        );
    }


    if (!pollAvailable || internalError || !isValidPollType) {
        return (
            <div className={styles.container}>
                <div className={styles.titleContainer}>
                    {window.width < 1000 ?
                        <YuJaLogo style={{marginRight: "5px", width: 60, height: 60, alignSelf: 'center'}}/>
                        : <YuJaLogo style={{marginRight: "5px", width: 95, height: 95, alignSelf: 'center'}}/>
                    }
                    <div className={styles.title}
                         style={{fontSize: window.width < 1000 ? 32 : 40}}>{t("questionBuilder.presentationQuestionPageTitle")}</div>
                </div>
                <div className={styles.resultBox} style={{width: window.width < 650 ? '80%' : 600}}>
                    {window.width < 1000 ?
                        <UnsupportedIcon style={{width: 180, height: 180}}/>
                        : <UnsupportedIcon style={{width: 270, height: 270}}/>
                    }
                    <div className={styles.resultTitle} style={{fontSize: window.width < 1000 ? 23 : 32}}>
                        {!pollAvailable && t("questionBuilder.presentationQuestionPollUnavailableTitle")}
                        {!isValidPollType && t("poll.unsupportedActivityTitle")}
                        {internalError && t("questionBuilder.presentationQuestionInternalErrorTitle")}
                    </div>
                    <div className={styles.description} style={{fontSize: window.width < 1000 ? 16 : 24}}>
                        {!pollAvailable && t("questionBuilder.presentationQuestionPollUnavailableText")}
                        {!isValidPollType && t("poll.releasePollSurveyPptError")}
                        {internalError && t("questionBuilder.presentationQuestionInternalErrorText")}
                    </div>
                </div>
            </div>
        );
    }


    // if (!!serialNo) {
    //     return (
    //         <ViewPresent
    //             pollData={pollData}
    //             serialNo={serialNo}
    //             resetData={resetCount}
    //             resetPollData={loadPublishedData}
    //         />
    //     );
    // }

    return (
        <div className={styles.container}>
            <ViewPresent
                pollData={pollData}
                serialNo={serialNo}
                resetData={resetCount}
                resetPollData={loadPublishedData}
                userSettings={userSettings}
            />
        </div>
    );
}